import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './signin/signin.component';
import { HomeLayoutComponent } from './shared/components/layout/home-layout/home-layout.component';
import { AdminLayoutComponent } from './shared/components/layout/admin-layout/admin-layout.component';
import { ErrorPageComponent } from './shared/components/errorpage/error-page.component';
import { ViewgalleryimagesComponent } from './admin/pages/gallery/components/viewgalleryimages/viewgalleryimages.component';
import { ViewupdateteammemberComponent } from './admin/pages/team/components/viewupdateteammember/viewupdateteammember.component';
import { NariComponent } from './nari/nari.component';

const routes: Routes = [
    { path: 'home', loadChildren: () => import('./home/home.module').then((m) => m.HomeModule), component: HomeLayoutComponent },
    {
        path: '',
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
        component: AdminLayoutComponent
    },
    {
        path: 'Login',
        component: SigninComponent
    },
    {
        path: 'nss',
        component: NariComponent
    },
    {
        path: '**',
        component: ErrorPageComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
